import { extractData } from "../../../../utils";
import { API_URL } from "../../../../utils/constant";
import { APIError, handleAPIError } from "../../../common/errorHandler";
import { getDecoratedUrl } from "../../../common/urlService";
import { getApiAsyn, baseUrl } from "../../../PostAPI";
import axios from "axios";

export const fetchUser = async (payload) => {
  const url = getDecoratedUrl({
    url: API_URL.SYSTEM_USERS.GET,
    payload,
  });
  try {
    let result = await getApiAsyn(url, localStorage.getItem("token"));

    if (result?.error) {
      throw new APIError(result);
    }
    return result || [];
    // return extractData(result, !payload?.filters);
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

export const fetchUsersById = async (payload) => {
  const url = API_URL.SYSTEM_USERS.GET_BY_ID.replace(":id", payload?.id);
  try {
    let result = await getApiAsyn(url, localStorage.getItem("token"));

    if (result?.error) {
      throw new APIError(result);
    }

    result = extractData(result, !payload?.filters);

    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

const dataUploadApi = (url, data, isEdit = false) => {
  const config = {
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      authorization: localStorage.getItem("token"),
    },
  };

  if (isEdit) {
    return axios.put(baseUrl + url, data, config);
  } else {
    return axios.post(baseUrl + url, data, config);
  }
};

export const updateUser = async (payload) => {
  const url = API_URL.SYSTEM_USERS.EDIT.replace(":id", payload?.id);

  try {
    let result = await dataUploadApi(url, payload.data, true);

    if (result?.error) {
      throw new APIError(result);
    }
    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

export const createUser = async (payload) => {
  const url = API_URL.SYSTEM_USERS.CREATE.replace(":id", payload?.id);

  try {
    let result = await dataUploadApi(url, payload);

    if (result?.error) {
      throw new APIError(result);
    }
    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

export const fetchUserRolesDropdown = async (payload) => {
  const url = API_URL.SYSTEM_USERS.ROLESDROPDOWN;
  try {
    let result = await getApiAsyn(url, localStorage.getItem("token"));

    if (result?.error) {
      throw new APIError(result);
    }

    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

export const fetchUserCreateMenuList = async (payload) => {
  const url = `${API_URL.SYSTEM_USERS.CREATE_MENU_LIST}?userId=${payload?.userId}`;
  try {
    const result = await getApiAsyn(url, localStorage.getItem("token"));

    if (result?.error) {
      throw new APIError(result);
    }

    return result;
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};


export const fetchAllLocations = async () => {
  const url = API_URL.SYSTEM_USERS.GET_LOCATIONS;
  try {
    let result = await getApiAsyn(url, localStorage.getItem("token"));

    if (result?.error) {
      throw new APIError(result);
    }
    return result || [];
  } catch (error) {
    console.error(error);
    return handleAPIError(error);
  }
};

